import React, { Component } from 'react';
import TextField from 'components/TextField';
import { setItem } from 'utils/localStorage';
import CustomButton from 'components/CustomButton';
import cn from 'classnames';
import ErrorMessage from 'components/ErrorMessage';
import renderIf from 'render-if';
import { regExForEmail } from 'constants/Regularexpression';
// import { ViewAthlete, CoachDashboard } from 'routes/routeNames';
import FullScreenLoader from 'components/FullScreenLoader';
import PropTypes from 'prop-types';
import UserInfo from 'containers/Admin/components/Userinfo';
import styles from './SearchUser.scss';

class SearchUser extends Component {
  static propTypes = {
    SearchUser: PropTypes.func.isRequired,
    searchUserRequested: PropTypes.bool.isRequired,
    searchUserData: PropTypes.bool.isRequired, // eslint-disable-line
    userType: PropTypes.string.isRequired,
    userInfo: PropTypes.shape.isRequired,
    catchUserInfo: PropTypes.func.isRequired,
    fieldHeader: PropTypes.string,
    label: PropTypes.string,
    searchHappened: PropTypes.bool.isRequired, // eslint-disable-line
    error: PropTypes.string.isRequired, // eslint-disable-line
  };
  static defaultProps = {
    fieldHeader: undefined,
    label: undefined,
  };
  constructor(props) {
    super(props);
    this.state = {
      user: '',
      username: '',
      errorMessage: '',
    };
  }
  componentWillReceiveProps(nextProps) {
    const { userType } = this.props;
    if ((nextProps.searchHappened && nextProps.searchUserData.size === 0) || nextProps.error !== '') {
      this.setState({ errorMessage: 'User not found.' });
    }
    if (nextProps.searchUserData.size > 0 && this.props.userInfo.name === undefined) {
      let results = nextProps.searchUserData.get('hits');
      const totalHits = results.get('hits').size;
      if (totalHits > 0) {
        results = results.get('hits');
        results = results.toJS();
        const firstItemFromElastic = results[0]._source; // eslint-disable-line
        if (userType === 'STUDENT') {
          setItem('user_cred', firstItemFromElastic.id);
          setItem('localZone', 'STUDENT');
          const football = firstItemFromElastic.sports.FOOTBALL;
          const userInfo = {
            name: firstItemFromElastic.fullname,
            student_id: firstItemFromElastic.id,
            email: firstItemFromElastic.sa_email,
            school: firstItemFromElastic.school,
            evaluationText: firstItemFromElastic.evaluation_text,
            overrideDivision: firstItemFromElastic.override_division,
            t40: football.t40,
            squats: football.squats,
            bench: football.bench,
            primaryOff: football.primary_offensive_position_pref,
            primaryDef: football.primary_defensive_position_pref,
            secondaryOff: football.secondary_defensive_position_pref,
            secondaryDef: football.secondary_defensive_position_pref,
            id: firstItemFromElastic.id,
          };
          this.props.catchUserInfo('studentInfo', userInfo);
        } else {
          setItem('user_cred', firstItemFromElastic.coach_id);
          setItem('localZone', 'COACH');
          const userInfo = {
            name: firstItemFromElastic.name,
            coach_id: firstItemFromElastic.coach_id,
            email: firstItemFromElastic.coach_email,
            college: firstItemFromElastic.college,
          };
          this.props.catchUserInfo('coachInfo', userInfo);
        }
      }
    }
  }
  userNameHandler = (username) => {
    this.setState({ username, errorMessage: '' });
  };

  identifyEnter = (e) => {
    const { username } = this.state;
    const { userType } = this.props;
    const code = (e.keyCode ? e.keyCode : e.which);
    if (code === 13) { // Enter keycode
      let payload = {};
      if (userType === 'STUDENT') {
        payload = Object.assign({
          sa_email: username,
        });
      } else {
        payload = Object.assign({
          coach_email: username,
        });
      }
      const validEmail = regExForEmail.test(username);
      if (username !== '' && validEmail) {
        this.props.SearchUser(payload, userType);
      } else {
        this.setState({ errorMessage: 'Please enter a valid username.' });
      }
    }
  };

  searchUser =() => {
    const { username } = this.state;
    const { userType } = this.props;
    let payload = {};
    if (userType === 'STUDENT') {
      payload = Object.assign({
        sa_email: username,
      });
    } else {
      payload = Object.assign({
        coach_email: username,
      });
    }
    const validEmail = regExForEmail.test(username);
    if (username !== '' && validEmail) {
      this.props.SearchUser(payload, userType);
    } else {
      this.setState({ errorMessage: 'Please enter a valid username.' });
    }
  };

  removeUserInfo = () => {
    this.props.catchUserInfo('studentInfo', {});
    this.props.catchUserInfo();
  };

  render() {
    const { searchUserRequested, userInfo, label, fieldHeader, userType } = this.props;
    const renderLoader = renderIf(searchUserRequested);
    const renderSearchComponent = renderIf(userInfo.name === undefined);
    const renderUserInfo = renderIf(userInfo.name !== undefined);
    return (
      <div className={cn('col s12', styles.removePadding)}>
        {renderLoader(
          <FullScreenLoader />,
          )}
        {renderUserInfo(
          <div>
            <UserInfo userInfo={userInfo} userType={userType} />
            {userType === 'STUDENT' ?
              <CustomButton
                type="submit" label="SEARCH ANOTHER USER"
                onClick={this.removeUserInfo}
                style={styles.buttonContainer}
              /> : '' }
          </div>
            ,
        )}
        {renderSearchComponent(
          <div className={cn('col s12 m4', styles.removePadding)}>
            <TextField
              label={fieldHeader === undefined ? 'ENTER USER EMAIL' : fieldHeader}
              onChange={this.userNameHandler} onKeyPress={this.identifyEnter}
            />
            <ErrorMessage message={this.state.errorMessage} />
            <CustomButton
              type="submit" label={label === undefined ? 'SEARCH USER' : label}
              onClick={this.searchUser}
            />
          </div>,
        )}
      </div>
    );
  }
}

export default SearchUser;



// WEBPACK FOOTER //
// ./src/components/SearchUser/SearchUser.js